export const MainConcreteRestoration = {
    "imageUrl": "/assets/imgs/services/8concreteRestoration/fondo.png",
    "eyebrow": "Concrete",
    "title": "Restoration",
    "headingSpan": "STRENGTHENING &",
    "heading": "PRESERVING YOUR BUILDING",
    "description": "Over time, concrete structures face cracking, spalling, and deterioration due to weather exposure, moisture infiltration, and general wear. At HRD Painting & Restoration, we specialize in comprehensive concrete restoration to repair, reinforce, and protect your building’s structural integrity, ensuring safety, longevity, and visual appeal.",
    "highlightSpan": "The best Building Envelope Renewal",
    "highlight": " / High-Rise Painting & Restoration services.",
    "button": {
        "text": "Request a Quote",
        "url": "/quote"
    }
};